import React from "react";
import { MusicPracticeRoomStep1ContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { withTranslation } from "react-i18next";
import queryString from "query-string";
import { userService } from "apiServices";
import { HeaderBackMusicPracticeWidget } from "widgets";
import { Displays, Forms, Headers, Navigations } from "components";

class MusicPracticeRoomStep1Container extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { router, i18n } = this.props;
    let res = await userService.GET_ROOM_LIST(`?pagination=false&type=2`);
    if (res && res.status === 200) {
      this.setState({
        roomOptions: res.data.docs
          .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
          .map((e) => ({
            label: i18n.language === "en" ? e.name_en : e.name_th,
            value: e._id,
          })),
        initialValues: {
          ...queryString.parse(router.location.search),
        },
        isLoading: false,
      });
    }
  };

  handleBack = () => {
    const { router } = this.props;
    router.navigate(ROUTE_PATH.MUSIC_PRACTICE_ROOM);
  };

  handleSubmit = (values) => {
    const { initialValues } = this.state;
    const queryString = new URLSearchParams({
      ...initialValues,
      ...values,
    }).toString();
    // เลือกห้องแล้วไปขั้นข้อมูลติดต่อก่อน แล้วค่อยไปเลือกวัน/เวลา (step 2)
    this.props.router.navigate(
      `${ROUTE_PATH.MUSIC_PRACTICE_ROOM}/${values.room_ref_id}/booking/contact?${queryString}`,
    );
  };

  render() {
    const { router, t } = this.props;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Music Practice Room", { ns: "common" }),
        path: `${ROUTE_PATH.MUSIC_PRACTICE_ROOM}`,
      },
    ];
    const isPreview =
      queryString.parse(router.location.search)?.is_preview === "true";
    const { isLoading, initialValues, roomOptions } = this.state;
    return (
      <MusicPracticeRoomStep1ContainerStyled>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="music_practice_container">
          {!isPreview ? (
            <div className="header_layout">
              <Headers.NewPageHeader
                title={"MUSIC PRACTICE ROOM"}
                sub_title={"ห้องซ้อมดนตรี"}
              />
            </div>
          ) : (
            <div className="header_backhome_layout">
              <HeaderBackMusicPracticeWidget
                room_booking_id={
                  queryString.parse(router.location.search)?.room_id
                }
              />
            </div>
          )}
          {isPreview && (
            <div className="title_preview">
              {t("Review Information", { ns: "common" })}
            </div>
          )}
          <div className="detail_layout">
            <Displays.TitleReserve
              title_reserve={t("Select Room", { ns: "room" })}
            />
          </div>
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <Forms.MusicPracticeRoomSelectRoomForm
              isDisabledForm={isPreview}
              initialValues={initialValues}
              roomOptions={roomOptions}
              onBack={this.handleBack}
              onSubmit={this.handleSubmit}
            />
          )}
        </div>
      </MusicPracticeRoomStep1ContainerStyled>
    );
  }
}

export default withTranslation(["common", "room"])(
  withRouter(MusicPracticeRoomStep1Container),
);
